module.exports = __webpack_public_path__ + "static/media/h9_arttherapy_bw.5b181a34.webp";